import styled from 'styled-components';

export const StyledDateRangePicker = styled.div`
	display: inline-block;
	.DateRangePicker{
		margin-right: 24px;
	}
	.DateInput_input {
		font-family: Poppins, Heltica, Arial, sans-serif;
		font-size: 12px;
		color: #425A70;
		padding: 2px 11px 2px;
		border-radius: 12px;
		border-bottom-color: transparent;
	}
	.DateInput.DateInput_1 {
		border-radius: 12px;
		width: 120px;
	}
	.DateRangePickerInput__withBorder {
		border-radius: 12px;
	}
	.DateRangePicker.DateRangePicker_1 {
	    border-radius: 12px;
	}
`;
